import React, { useMemo } from 'react'

// material ui
import Tooltip from '@mui/material/Tooltip'

import styled from 'styled-components'

// constants
import aampeTheme from '../../../constants/aampeTheme'
import ICONS from '../../../constants/icons'

// hooks
import useDatasetByIdQuery from '../../../hooks/datasets/useDatasetByIdQuery'

const DatasetElement = ({ element, handleSelection }) => {
    const { data } = useDatasetByIdQuery(element.datasetId)
    const dataset = data ? data : null
    const datasetDetails = {
        kind: 'dataset',
        variantType: element.variantType,
        elementId: element.id,
        datasetId: element.datasetId,
        datasetField: element.datasetField,
    }
    const datasetField =
        dataset && dataset.fields
            ? dataset.fields.find((field) => field.id === element.datasetField)
            : null
    const datasetValue = datasetField ? datasetField.sample : null
    const isMultiValue = datasetValue ? Array.isArray(datasetValue) : false
    let sampleString = isMultiValue
        ? datasetValue[0]
        : datasetValue
        ? datasetValue
        : 'Unknown Dataset'

    if (typeof sampleString !== 'string') {
        sampleString = JSON.stringify(sampleString)
    }

    const AampeToolTipTitle = useMemo(() => {
        return (
            <div>
                <div>Dataset name: {data?.name}</div>
                <div>Field name: {datasetField?.name}</div>
                <div>Sample: {datasetField?.sample}</div>
            </div>
        )
    }, [data, datasetField])

    return (
        <Tooltip placement="top" arrow title={AampeToolTipTitle}>
            <StyledSpan
                elementType={
                    element.variantType ? element.variantType : 'Dataset'
                }
                onClick={() => handleSelection(datasetDetails)}
            >
                <StyledIcon />
                {sampleString}
            </StyledSpan>
        </Tooltip>
    )
}

const StyledSpan = styled.span({
    userSelect: 'none',
    outline: 'none',
    display: 'inline-block',
    borderRadius: aampeTheme.borderRadius.default,
    backgroundColor: aampeTheme.colors.interactiveWG01,
    padding: aampeTheme.spacing4(0, 1),
    color: aampeTheme.colors.neutral09,
    lineHeight: '24px',
    fontSize: aampeTheme.size.font.default,
    fontWeight: 400,
    minWidth: '30px',
    border: `1px solid ${aampeTheme.colors.solidA02}`,
})

const StyledIcon = styled(ICONS.datasets)({
    lineHeight: '20px',
    verticalAlign: 'middle',
    margin: aampeTheme.spacing4(0, 2, 0, 0),
    color: aampeTheme.colors.textAccessibleWG01,
    width: '16px',
    height: '16px',
})

export default DatasetElement
